import { gql, useFragment } from "@apollo/client";

// Styling
import style from "./search-icon.module.scss";

// Components
import Link from "next/link";
import IconFA from "../icon-fa/icon-fa";
import Button from "../button/button";

export default function SearchIcon({ entry, searchClickState = {} }) {
  // Use Fragment
  const { complete, data } = useFragment({
    fragment: SearchIcon.fragments.entry,
    fragmentName: "SearchIconFragment",
    from: {
      __typename: entry.__typename,
      id: entry.id,
    },
  });
  if (!complete) {
    return;
  }

  // -- Set State
  // - Search Dropdown State
  const searchState = searchClickState["searchState"];
  const setSearchState = searchClickState["setSearchState"];
  const searchDropdownState = searchState ? "open" : "closed";

  // Define Variables
  const searchMode = data.searchMode[0];
  const ariaPart = searchState ? "Close" : "Open";

  return (
    <div className="searchIcon">
      {searchMode === "page" && (
        <Link href="/?s=" className="icon--search" type="button">
          <IconFA name="faMagnifyingGlass" color="var(--color--font)" />
        </Link>
      )}
      {searchMode === "dropdown" && (
        <Button
          className={style.iconSearch}
          ariaAtts={{ "aria-label": ariaPart + " search dropdown" }}
          state={searchDropdownState}
          onClick={() => setSearchState(!searchState)}
        >
          <IconFA name="faMagnifyingGlass" color="var(--color--font)" />
          <IconFA name="faClose" color="var(--color--font)" />
        </Button>
      )}
    </div>
  );
}

SearchIcon.fragments = {
  entry: gql`
    fragment SearchIconFragment on GeneralSettingsACFSearchSettings {
      searchMode
    }
  `,
};
